import { useNavigate } from "react-router-dom"

import { Button } from "@/components/button"
import { Card } from "@/components/card"
import { FeesIcon } from "@/domains/icons"

export const NoFeesView = () => {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center gap-2 bg-p300 p-4">
      <Card.HeaderIconContainer>
        <FeesIcon className="h-4 w-4 text-t200" />
      </Card.HeaderIconContainer>
      <div className="flex flex-col items-center justify-center">
        <Card.HeaderTitle>Fees</Card.HeaderTitle>
        <div className="text-xs text-t200">Fees are earned when you provide liquidity without staking for rewards.</div>
      </div>
      <Button
        variant="percentage"
        onClick={() => {
          navigate("/liquidity")
        }}
      >
        Start Earning
      </Button>
    </div>
  )
}
